import { Route } from "react-router-dom";
import PublicPronunciationPage from "@pages/public/pronunciation/PublicPronunciationPage";
import PublicPronunciationPageV2 from "@pages/public/pronunciation/PublicPronunciationPageV2";
import PublicSpokenDialoguePage from "@pages/public/spoken-dialogue/PublicSpokenDialoguePage";

export const publicRoutes = [
  <Route
    key="public-pronunciation"
    path="/pronunciation-student/:code"
    element={<PublicPronunciationPage />}
  />,
  <Route
    key="public-pronunciation-v2"
    path="/pronunciation-student/v2/:code"
    element={<PublicPronunciationPageV2 />}
  />,
  <Route
    key="public-spoken-dialogue"
    path="/content/spoken-dialogue/public/:code"
    element={<PublicSpokenDialoguePage />}
  />,
];
